import {createStore, applyMiddleware, compose} from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from '../redux/reducers/rootReducer'
import thunk from 'redux-thunk'
import reduxReset from 'redux-reset'

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['auth']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default () => {
	let store = createStore(
		persistedReducer,
		composeEnhancer(
			reduxReset(),
			applyMiddleware(thunk)
		)

	)
	let persistor = persistStore(store)
	return { store, persistor }
}



// WEBPACK FOOTER //
// ./src/store/store.js